import { AppDialog } from "../../../../../common/components/AppDialog/AppDialog";
import {
  IfFalse,
  IfTrue,
  RenderWhen,
} from "../../../../../common/infrastructure/components/RenderWhen";
import { Icon, IconType } from "../../../../../common/icons/Icon";
import { NO_CLIENT_EMAIL_MESSAGE, useSendClientFormDialog } from "../hooks/useSendClientFormDialog";
import { IUserModel } from "../models/userModel";
import styles from "./SendClientFormDialog.module.scss";

interface ISendClientFormDialogProps {
  visible: boolean;
  onHide: () => void;
  user?: IUserModel;
}

/** Lists the studio's forms; each can be emailed to the client to fill in on its own. */
export const SendClientFormDialog = ({ visible, onHide, user }: ISendClientFormDialogProps) => {
  const { forms, isLoading, isSending, requestSend } = useSendClientFormDialog({
    user,
    visible,
    onHide,
  });
  const email = user?.email?.trim();

  return (
    <AppDialog
      header="Изпрати форма"
      visible={visible}
      className={styles.dialog}
      onHide={onHide}
    >
      <p className={styles.recipient}>
        <RenderWhen condition={!!email}>
          <IfTrue>
            <>
              Линкът ще бъде изпратен на: <span className={styles.recipient_email}>{email}</span>
            </>
          </IfTrue>
          <IfFalse>
            <span className={styles.recipient_missing}>{NO_CLIENT_EMAIL_MESSAGE}</span>
          </IfFalse>
        </RenderWhen>
      </p>

      <div className={styles.list}>
        <RenderWhen condition={!isLoading && forms.length === 0}>
          <IfTrue>
            <div className={styles.empty}>
              Обектът няма активни форми. Добавете от Администрация → Други → Форми.
            </div>
          </IfTrue>
          <IfFalse>
            {forms.map((form) => (
              <button
                type="button"
                key={form.id}
                className={styles.row}
                disabled={isSending}
                onClick={() => requestSend(form)}
              >
                <span className={styles.row_name}>{form.name}</span>
                <span className={styles.row_action}>
                  Изпрати
                  <Icon
                    type={IconType.SendIcon}
                    color="currentColor"
                    width="16px"
                    height="16px"
                  />
                </span>
              </button>
            ))}
          </IfFalse>
        </RenderWhen>
      </div>
    </AppDialog>
  );
};
